import {
  colors,
  fonts,
  fontSizes,
  radii,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export const linkStyles = stylex.create({
  stack: { display: "flex", flexDirection: "column", gap: spacing.space8 },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space8,
    padding: 0,
    margin: 0,
    listStyle: "none",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space4,
    padding: spacing.space8,
    borderWidth: 1,
    borderStyle: "dashed",
    borderColor: colors.borderStrong,
    borderRadius: radii.small,
  },
  actions: { display: "flex", flexWrap: "wrap", gap: spacing.space4 },
  label: {
    margin: 0,
    color: colors.muted,
    fontFamily: fonts.mono,
    fontSize: fontSizes.caption,
    lineHeight: 1.5,
  },
  error: {
    color: colors.danger,
    fontFamily: fonts.mono,
    fontSize: fontSizes.caption,
  },
});
